import { render } from "./CardGroup.vue?vue&type=template&id=1820a21c"
import script from "./CardGroup.vue?vue&type=script&lang=js"
export * from "./CardGroup.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__